var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import * as _ from "lodash";
import { splitManagementGroupPath, isClassicWorkspaceByName, getManagementGroupLevels, isClassicWorkspaceById } from "@ane/exp-data/lib/utils/ManagementGroup/ManagementGroup.utils";
class TenantPageUtils {
  constructor() {
    __publicField(this, "MsftWorkspaceRootGroup", "microsoft");
  }
  convertToManagementGroup(group) {
    const pathSegments = splitManagementGroupPath(group.Path);
    return {
      id: group.ID,
      name: group.Name,
      path: group.Path,
      depth: isClassicWorkspaceByName(group.WorkspaceName) ? pathSegments.length : pathSegments.length - 1
    };
  }
  getWorkspaceGroup(workspaceId, path) {
    const { level1, level2 } = getManagementGroupLevels(path);
    return isClassicWorkspaceById(workspaceId) ? level1 : level2;
  }
  getSortedWorkspaceGroups(groups) {
    const firstLevelGroups = (groups || []).map((t) => this.convertToManagementGroup(t)).filter((t) => !!(t == null ? void 0 : t.name) && t.depth === 1);
    return _.sortBy(firstLevelGroups, (t) => t.name.toLocaleLowerCase());
  }
  convertAzureResourceToWorkspaces(result) {
    if (result === null) {
      return [];
    } else {
      return result.data.rows.map((r) => this.convertToWorkspace(result.data.columns, r));
    }
  }
  convertToWorkspace(columns, row) {
    const idIdx = _.findIndex(columns, (c) => c.name === "workspaceId");
    const nameIdx = _.findIndex(columns, (c) => c.name === "name");
    return {
      id: row[idIdx].toLocaleLowerCase(),
      name: row[nameIdx]
    };
  }
}
const TenantPageUtils$1 = new TenantPageUtils();
export {
  TenantPageUtils,
  TenantPageUtils$1 as default
};
//# sourceMappingURL=TenantPageUtils.js.map
